import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const InputGroup = lazy(
    () => import(/* webpackChunkName: "input-group" */ '../../../shared/form/input-group')
);

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = {
            old_password: null,
            new_password: null,
            confirm_new_password: null,
        };
    }

    componentShouldUpdate(nextProps) {
        if (nextProps.success && !this.props.success) {
            this.setState({
                old_password: null,
                new_password: null,
                confirm_new_password: null,
            });
        }
    }

    render({ errors, success }, { old_password, new_password, confirm_new_password }) {
        return (
            <password>
                <row className='is-wrap'>
                    <column className='is-12'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <InputGroup
                                label='Current Password'
                                type='password'
                                name='old_password'
                                value={success ? null : old_password}
                                error={errors && errors.old_password}
                                onInput={this.handleChange}
                                autoComplete='new-password'
                            />
                        </Suspense>
                    </column>
                    <column className='is-12'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <InputGroup
                                label='New Password'
                                type='password'
                                name='new_password'
                                value={success ? null : new_password}
                                error={errors && errors.new_password}
                                onInput={this.handleChange}
                                autoComplete='new-password'
                            />
                        </Suspense>
                    </column>
                    <column className='is-12'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <InputGroup
                                label='Confirm New Password'
                                type='password'
                                name='confirm_new_password'
                                value={success ? null : confirm_new_password}
                                error={errors && errors.confirm_new_password}
                                onInput={this.handleChange}
                                autoComplete='new-password'
                            />
                        </Suspense>
                    </column>
                </row>
            </password>
        );
    }

    handleChange = (e) => {
        let state = this.state;
        let old_password_error = false;
        let new_password_error = false;
        let confirm_new_password_error = false;

        state[e.target.name] = e.target.value;

        if ((state.new_password || state.confirm_new_password) && !state.old_password) {
            old_password_error = 'This field is required';
        }

        if (state.new_password && !state.confirm_new_password) {
            confirm_new_password_error = 'This field is required';
        } else if (!state.new_password && state.confirm_new_password) {
            new_password_error = 'This field is required';
        } else if (!state.new_password && !state.confirm_new_password && state.old_password) {
            new_password_error = 'This field is required';
            confirm_new_password_error = 'This field is required';
        } else if (state.new_password != state.confirm_new_password) {
            new_password_error = 'Password fields must match';
            confirm_new_password_error = 'Password fields must match';
        } else if (state.new_password && state.new_password.length < 4) {
            new_password_error = 'Please enter a password longer than 3 characters';
            confirm_new_password_error = 'Please enter a password longer than 3 characters';
        }

        this.setState(state);

        this.props.onChange('old_password', state.old_password, old_password_error);
        this.props.onChange('new_password', state.new_password, new_password_error);
        this.props.onChange('confirm_new_password', state.confirm_new_password, confirm_new_password_error);
    }
}

const mapStateToProps = (state) => ({
    errors: state.settings && state.settings.errors,
    success: state.settings && state.settings.success,
});

export default connect(mapStateToProps)(Component);
